import { useState } from 'react';
import { PROJECTS_LIST } from '../../../mocks/auth';

const LS_KEY = 'portal_saved_project';

export default function MyProjects() {
  const [selected, setSelected] = useState<string | null>(() => localStorage.getItem(LS_KEY));
  const [saved, setSaved] = useState<string | null>(() => localStorage.getItem(LS_KEY));
  const [showSuccess, setShowSuccess] = useState(false);

  function handleToggle(id: string) {
    setSelected((prev) => (prev === id ? null : id));
  }

  function handleSave() {
    if (!selected) return;
    setSaved(selected);
    localStorage.setItem(LS_KEY, selected);
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 5000);
  }

  return (
    <div className="max-w-4xl relative">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-white mb-1">Мои проекты</h2>
        <p className="text-slate-500 text-sm">Выберите направление, в котором будете работать</p>
      </div>

      {/* Success toast */}
      {showSuccess && (
        <div className="fixed top-6 right-6 z-50 flex items-center gap-3 bg-emerald-500/95 text-white rounded-2xl px-5 py-4 shadow-lg animate-pulse max-w-sm">
          <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-checkbox-circle-fill text-lg" />
          </span>
          <p className="text-sm font-medium leading-snug">
            Мы зафиксировали Ваш выбор проекта. Вы сможете поменять его в будущем. Финальное закрепление происходит после оформления.
          </p>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {PROJECTS_LIST.map((project) => {
          const isSelected = selected === project.id;
          const isSaved = saved === project.id;
          return (
            <div
              key={project.id}
              onClick={() => handleToggle(project.id)}
              className={`relative bg-[#13161f] border rounded-2xl p-6 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 ${
                isSelected
                  ? 'border-emerald-500/50 bg-emerald-500/5'
                  : 'border-[#1e2130] hover:border-[#2a2d3e]'
              }`}
            >
              <div className="flex items-start gap-4">
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0"
                  style={{ background: `${project.color}18`, border: `1px solid ${project.color}30` }}
                >
                  <i className={`${project.icon} text-xl`} style={{ color: project.color }} />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <h3 className="text-sm font-bold text-white">{project.title}</h3>
                    {isSaved && (
                      <span className="text-xs text-emerald-400 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-2 py-0.5 whitespace-nowrap">
                        Текущий
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-slate-500 leading-relaxed">{project.description}</p>
                </div>

                <div className={`w-5 h-5 rounded-md flex-shrink-0 flex items-center justify-center border transition-all duration-200 mt-0.5 ${
                  isSelected
                    ? 'bg-emerald-500 border-emerald-500'
                    : 'border-[#2a2d3e] bg-[#1a1d28]'
                }`}>
                  {isSelected && <i className="ri-check-line text-white text-xs" />}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-between bg-[#13161f] border border-[#1e2130] rounded-2xl px-6 py-4">
        <p className="text-sm text-slate-500">
          {selected
            ? `Выбрано: ${PROJECTS_LIST.find((p) => p.id === selected)?.title}`
            : 'Проект не выбран'}
        </p>
        <button
          onClick={handleSave}
          disabled={!selected || selected === saved}
          className="bg-emerald-500 hover:bg-emerald-400 disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold rounded-xl px-6 py-2.5 text-sm transition-all cursor-pointer whitespace-nowrap"
        >
          Сохранить выбор
        </button>
      </div>
    </div>
  );
}
